import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';

export abstract class BasePolicyAgentDO extends BaseDO {
    
    public agentNum:string;
    public primaryFl:boolean;
    public commissionPercent:number;

 }